module.exports = __webpack_public_path__ + "static/img/zzc_sjec.1d33db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zzc_sjec.png
// module id = K6Z8
// module chunks = 2